<div class="order-component" #orderComponent>
  <h1>Оформление заказа</h1>


  <div class="order-form" #form>

    <div class="step" *ngIf="pageIndex == 0">
      <ng-container *ngTemplateOutlet="firstStep"></ng-container>
    </div>
    <div class="step" *ngIf="pageIndex == 1">
      <ng-container *ngTemplateOutlet="secondStep"></ng-container>
    </div>
    <div class="step" *ngIf="pageIndex == 2">
      <ng-container *ngTemplateOutlet="thirdPage"></ng-container>
    </div>
    <div class="step" *ngIf="pageIndex == 3">
      <ng-container *ngTemplateOutlet="productsListPage"></ng-container>
    </div>
    <div class="step" *ngIf="pageIndex == 4">
      <ng-container *ngTemplateOutlet="submitPage"></ng-container>
    </div>
    <mat-error
      *ngIf="orderHasErrors" class="order-error">В заказе ошибки, проверьте правильность заполнения полей
    </mat-error>

  </div>
  <div class="information"> * - Поля обязательные для заполнения</div>
  <div class="buttons-block">
    <div style=" visibility: hidden;" *ngIf="pageIndex == 0"></div>
    <button mat-button class="main-button previous" *ngIf="pageIndex != 0" (click)="changeStep(-1)">Назад</button>
    <button mat-button class="main-button next" *ngIf="pageIndex != pageCount -1" (click)="changeStep(1)">Далее</button>
    <button mat-button class="main-button submit" type="submit" *ngIf="pageIndex == pageCount -1" (click)="payOrder()"
            [disabled]="!order.concentDataProcessing || orderHasErrors">Оплатить
    </button>


  </div>
  <payment #paymentComponent
           [showEmail]="false"
           style="visibility: hidden;width:0"
  ></payment>
</div>

<ng-template #firstStep>
  <h2>Информация о получателе</h2>

  <div class="field">
    <mat-label for="name"><span class="required-sign">*</span>Фамилия, имя (латиницей):</mat-label>

    <input id="name" name="name"
           class="order-input" type="text"
           [mask]="'S* S*'"
           [validation]="false"
           [(ngModel)]="order.name" [formControl]="nameControl">
    <mat-error *ngIf="nameControl.errors">{{getErrorText(nameControl.errors)  }}</mat-error>
  </div>

  <div class="field">
    <mat-label for="email"><span class="required-sign">*</span>email:</mat-label>
    <input id="email" name="email" type="email" [(ngModel)]="order.email" [formControl]="emailControl">
    <mat-error
      *ngIf="emailControl.errors">{{getErrorText(emailControl.errors)}}</mat-error>
  </div>

  <div class="field">
    <mat-label for="nif">{{taxesName}}:</mat-label>
    <input id="nif" name="nif" type="number" [(ngModel)]="order.nif" [formControl]="nifControl">
    <mat-error
      *ngIf="nifControl.errors">{{getErrorText(nifControl.errors)}}</mat-error>
  </div>

  <div class="field">
    <mat-label for="phone"><span class="required-sign">*</span>Телефон:</mat-label>
    <input id="phone"
           name="phone" type="text"
           mask="+000 000 000 099"
           [dropSpecialCharacters]="false"
           [(ngModel)]="order.phoneNumber"
           [formControl]="phoneControl"
           [validation]="false"
    >

    <mat-error *ngIf="phoneControl.errors">{{getErrorText(phoneControl.errors)}}</mat-error>
  </div>


</ng-template>

<ng-template #secondStep>

  <h2 *ngIf="this.productsToOrder.length > 0 && this.productsInStock.length > 0">
    <div class="field">
      <mat-checkbox class="confirm-checkbox" [(ngModel)]="order.jointDelivery"> Оформить совместную доставку для товаров
        под
        заказ и из наличия? <br/>
        Оплата за раздельную доставку оплачивается для каждого заказа отдельно.

      </mat-checkbox>
      <mat-error
        *ngIf="concentNewslettersControl.errors">{{getErrorText(concentNewslettersControl.errors)}}</mat-error>
    </div>
  </h2>

  <h2>Выберите тип доставки</h2>
  <mat-radio-group id="delivery-type"
                   class="radio-group"
                   [(ngModel)]="deliveryType" name="deliveryType"
                   [name]="'first'"
                   [formControl]="deliveryTypeControl">
    <mat-radio-button *ngFor="let i of getDeliveryTypes()"
                      [value]="i.type"
                      [id]="i.type"
    >
      <div class="delivery-type">
        <div class="delivery-name"> {{deliveryTypeNames[i.type]}}</div>
        <div class="delivery-price">Стоимость доставки {{i.price  | number : '1.2-2' | currency: "EUR"}}</div>
      </div>
    </mat-radio-button>
  </mat-radio-group>

  <mat-error *ngIf="deliveryTypeControl.errors">{{getErrorText(deliveryTypeControl.errors)}}</mat-error>


  <div *ngIf="!pickPointsShow && !showAddress && !postamatDelivery && deliveryType" class="delivery-address">
    <h2>Забрать из магазина</h2>

    <div>
      {{getMainPickPointAddress()}}
    </div>
  </div>


  <div *ngIf="postamatDelivery && deliveryType" class="delivery-address">
    <h2>Данные постамата</h2>

    <div class="postamatInfo">Выбрать постамат можно по ссылке <a href="https://boxnow.gr/en/locker-finder" target="_blank">boxnow.gr</a></div>

    <div class="field">
      <mat-label for="postamatId"><span class="required-sign">*</span>Идентификатор постамата (Locker ID):</mat-label>
      <input id="postamatId" name="postamatId" [(ngModel)]="order.postamatId"
             [formControl]="postamatIdControl">
      <mat-error *ngIf="postamatIdControl.errors">{{getErrorText(postamatIdControl.errors)}}</mat-error>
    </div>
    <div class="field">
      <mat-label for="postamatAddress"><span class="required-sign">*</span>Адрес постамата:</mat-label>
      <input id="postamatAddress" name="postamatAddress" type="text" [(ngModel)]="order.postamatAddress"
             [formControl]="postamatAddressControl">
      <mat-error *ngIf="postamatAddressControl.errors">{{getErrorText(postamatAddressControl.errors)}}</mat-error>
    </div>
  </div>


  <div class="delivery-address" *ngIf="pickPointsShow">
    <h2>Выберите пункт выдачи</h2>

    <div>

      <mat-radio-group id="pickPoints" class="radio-group pickpoints"
                       [(ngModel)]="pickPoint" name="pickPoints"
                       [formControl]="pickPointControl">
        <mat-radio-button *ngFor="let i of pickPoints" [value]="i.id"
                          [id]="i.id">
          {{getStringAddress(i)}}
        </mat-radio-button>
      </mat-radio-group>


      <mat-error *ngIf="pickPointControl.errors">{{getErrorText(pickPointControl.errors)}}</mat-error>
    </div>
  </div>

  <div class="delivery-address" *ngIf="showAddress">
    <h2>Адрес доставки</h2>


    <div class="field">
      <mat-label for="postalCode"><span class="required-sign">*</span>Индекс:</mat-label>
      <input id="postalCode" name="postalCode" [(ngModel)]="order.postalCode"
             [formControl]="postalCodeControl">
      <mat-error *ngIf="postalCodeControl.errors">{{getErrorText(postalCodeControl.errors)}}</mat-error>
    </div>
    <div class="field">
      <mat-label for="country"><span class="required-sign">*</span>Страна:</mat-label>
      <input id="country" name="country" type="text" [(ngModel)]="order.country"
             [formControl]="countryControl">
      <mat-error *ngIf="countryControl.errors">{{getErrorText(countryControl.errors)}}</mat-error>
    </div>
    <div class="field">
      <mat-label for="region">Регион:</mat-label>
      <input id="region" name="region" type="text" [(ngModel)]="order.region" [formControl]="regionControl">
    </div>
    <div class="field">
      <mat-label for="city"><span class="required-sign">*</span>Город:</mat-label>
      <input id="city" name="city" type="text" [(ngModel)]="order.city" [formControl]="cityControl">
      <mat-error *ngIf="cityControl.errors">{{getErrorText(cityControl.errors)}}</mat-error>
    </div>
    <div class="field">
      <mat-label for="street"><span class="required-sign">*</span>Улица:</mat-label>
      <input id="street" name="street" type="text" [(ngModel)]="order.street"
             [formControl]="streetControl">
      <mat-error *ngIf="streetControl.errors">{{getErrorText(streetControl.errors)}}</mat-error>
    </div>
    <div class="field">
      <mat-label for="buildingNumber"><span class="required-sign">*</span>Дом:</mat-label>
      <input id="buildingNumber" name="buildingNumber" type="text" [(ngModel)]="order.buildingNumber"
             [formControl]="buildingNumberControl">
      <mat-error *ngIf="buildingNumberControl.errors">{{getErrorText(buildingNumberControl.errors)}}</mat-error>
    </div>
    <div class="field">
      <mat-label for="appartmentNumber">Квартира:</mat-label>
      <input id="appartmentNumber" name="appartmentNumber" type="text"
             [(ngModel)]="order.appartmentNumber"
             [formControl]="appartmentNumberControl">
      <mat-error *ngIf="appartmentNumberControl.errors">{{getErrorText(appartmentNumberControl.errors)}}</mat-error>
    </div>
  </div>


</ng-template>

<ng-template #thirdPage>
  <div class="field">
    <mat-checkbox class="confirm-checkbox" [(ngModel)]="order.concentDataProcessing"
                  [formControl]="concentDataProcessingControl"><span class="required-sign">*</span> Подтверждаю согласие
      на обработку персональных
      данных
    </mat-checkbox>
    <mat-error
      *ngIf="concentDataProcessingControl.errors">{{getErrorText(concentDataProcessingControl.errors)}}</mat-error>
  </div>
  <div class="field">
    <mat-checkbox class="confirm-checkbox" [(ngModel)]="order.concentNewsletters">Подписаться на рассылку
    </mat-checkbox>
    <mat-error *ngIf="concentNewslettersControl.errors">{{getErrorText(concentNewslettersControl.errors)}}</mat-error>
  </div>


</ng-template>
<ng-template #productsListPage>

  <div *ngIf="screenWidth> 600">
    <ng-container *ngTemplateOutlet="ordersInfoWideScreen"></ng-container>
  </div>
  <div *ngIf="screenWidth < 600">
    <ng-container *ngTemplateOutlet="ordersInfoSmallScreen"></ng-container>
  </div>


</ng-template>

<ng-template #submitPage>
  <div class="field">
    <mat-checkbox class="confirm-checkbox" [(ngModel)]="order.concentDataProcessing"
                  [formControl]="concentDataProcessingControl"> Подтверждаю согласие на обработку персональных
      данных
    </mat-checkbox>
    <mat-error
      *ngIf="concentDataProcessingControl.errors">{{getErrorText(concentDataProcessingControl.errors)}}</mat-error>
  </div>
  <div class="field">
    <mat-checkbox class="confirm-checkbox" [(ngModel)]="order.concentNewsletters">Подписаться на рассылку
    </mat-checkbox>
    <mat-error *ngIf="concentNewslettersControl.errors">{{getErrorText(concentNewslettersControl.errors)}}</mat-error>
  </div>


</ng-template>


<ng-template #dialog class="delete-dialog">
  <div *ngIf="!canDeactivatePage">
    <h2 mat-dialog-title>Вы действительно хотите прервать оформление заказа?</h2>
    <div mat-dialog-actions>
      <button class="main-button cancel" mat-button [mat-dialog-close]="true" (click)="onSubmit('cancelled')">Да
      </button>
      <button class="main-button" mat-button mat-dialog-close [mat-dialog-close]="false">Нет</button>
    </div>
  </div>
</ng-template>

<ng-template #ordersInfoWideScreen>
  <div class="spinner" *ngIf="loadOrder">
    <mat-spinner></mat-spinner>
  </div>
  <div *ngIf="!loadOrder">
    <div *ngIf="productsInStock.length > 0 || productsToOrder.length > 0" class="products">
      <h2 *ngIf="productsInStock.length > 0" class="color-accent">Товары в наличии</h2>
      <h2 *ngIf="productsToOrder.length > 0 && productsInStock.length == 0" class="color-accent">Товары под заказ</h2>
      <div class="product-table">
        <div class="table-header">
          <div>Наименование</div>
          <div class="small-screen-hidden">Количество</div>
          <div class="small-screen-hidden">Цена, {{' \u20AC'}} (за шт.)</div>
          <div>Итоговая цена, {{' \u20AC'}}</div>
        </div>
        <div *ngFor="let pr of productsInStock" class="table-row">
          <div>{{pr.product.author}} {{pr.product.name}}</div>
          <div class="small-screen-hidden">{{pr.count}}</div>
          <div class="small-screen-hidden"> {{pr.product.discountPriceEuro  | number : '1.2-2' }}</div>
          <div>{{pr.product.discountPriceEuro * pr.count  | number : '1.2-2' }}</div>
        </div>
        <div *ngIf="productsInStock.length == 0">
          <div *ngFor="let pr of productsToOrder" class="table-row">
            <div>{{pr.product.author}} {{pr.product.name}}</div>
            <div class="small-screen-hidden">{{pr.count}}</div>
            <div class="small-screen-hidden"> {{pr.product.discountPriceEuro  | number : '1.2-2' }}</div>
            <div>{{pr.product.discountPriceEuro * pr.count  | number : '1.2-2' }}</div>
          </div>
        </div>

        <div class="table-row">
          <div>Итого</div>
          <div></div>
          <div></div>
          <div>{{order.discountPrice | number : '1.2-2'}}</div>
        </div>
        <div class="table-header" *ngIf="order.promoCode">
          <div>Итого c учетом промокода</div>
          <div></div>
          <div></div>
          <div>{{order.promoPrice | number : '1.2-2'}}</div>
        </div>
        <div class="table-header" *ngIf="order.payForDelivery">
          <div>Доставка</div>
          <div></div>
          <div></div>
          <div>{{order.deliveryType.price | number : '1.2-2' }}</div>
        </div>
        <div *ngIf="productsInStock.length == 0">
          <div class="table-header amount">
            <div>Предоплата (минимальная)</div>
            <div></div>
            <div></div>
            <div>{{order.fullPrice / 2| number : '1.2-2' }}</div>
          </div>
        </div>
        <div *ngIf="productsInStock.length > 0">
          <div class="table-header amount">
            <div>К оплате</div>
            <div></div>
            <div></div>
            <div>{{order.fullPrice | number : '1.2-2' }}</div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="productsToOrder.length > 0 && productsInStock.length > 0" class="products">
      <h2 class="color-accent">Товары под заказ2</h2>
      <div class="product-table">
        <div class="table-header">
          <div>Наименование</div>
          <div class="small-screen-hidden">Количество</div>
          <div class="small-screen-hidden">Цена (за шт.), {{' \u20AC'}} </div>
          <div>Итоговая цена, {{' \u20AC'}} </div>
        </div>
        <div *ngFor="let pr of productsToOrder" class="table-row">
          <div>{{pr.product.author}} {{pr.product.name}}</div>
          <div class="small-screen-hidden">{{pr.count}}</div>
          <div class="small-screen-hidden"> {{pr.product.discountPriceEuro | number : '1.2-2' }}</div>
          <div>{{pr.product.discountPriceEuro * pr.count  | number : '1.2-2' }}</div>
        </div>
        <div class="table-row">
          <div>Итого</div>
          <div></div>
          <div></div>
          <div>{{preorder.discountPrice | number : '1.2-2' }}</div>
        </div>
        <div class="table-header" *ngIf="order.promoCode">
          <div>Итого c учетом промокода</div>
          <div></div>
          <div></div>
          <div>{{preorder.promoPrice | number : '1.2-2'}}</div>
        </div>
        <div class="table-header" *ngIf="preorder.payForDelivery">
          <div>Доставка</div>
          <div></div>
          <div></div>
          <div>{{preorder.deliveryType.price | number : '1.2-2' }}</div>
        </div>
        <!--        <div class="table-header amount">-->
        <!--          <div>К оплате *</div>-->
        <!--          <div></div>-->
        <!--          <div></div>-->
        <!--          <div>{{preorder.fullPrice | number : '1.2-2' }}</div>-->
        <!--        </div>-->
        <div class="table-header amount">
          <div>Предоплата (минимальная)</div>
          <div></div>
          <div></div>
          <div>{{preorder.fullPrice / 2 | number : '1.2-2' }}</div>
        </div>
      </div>
    </div>

    <div *ngIf="certificates.length > 0" class="products">
      <h2 class="color-accent">Подарочные сертификаты</h2>
      <div class="product-table">
        <div class="table-header">
          <div>Наименование</div>
          <div class="small-screen-hidden">Количество</div>
          <div class="small-screen-hidden">Цена (за шт.), {{' \u20AC'}} </div>
          <div>Итоговая цена, {{' \u20AC'}} </div>
        </div>

        <div *ngFor="let cert of certificates" class="table-row">
          <div>Подарочный сертификат {{cert.certificate.amount  | number : '1.2-2'}} </div>
          <div class="small-screen-hidden">{{cert.count}}</div>
          <div class="small-screen-hidden"> {{cert.certificate.amount  | number : '1.2-2' }}</div>
          <div>{{cert.certificate.amount * cert.count  | number : '1.2-2'}}</div>
        </div>
        <div class="table-header amount">
          <div>К оплате</div>
          <div></div>
          <div></div>
          <div>{{certificatesOrder.orderPrice | number : '1.2-2' }}</div>
        </div>
      </div>
    </div>

    <div class="products" *ngIf="cartService.getGiftCardsFromStorage().length > 0">
      <h2 class="color-accent">Оплата подарочными сертификатами</h2>
      <div class="product-table">
        <div *ngFor="let cert of cartService.getGiftCardsFromStorage()" class="table-row">
          <div>Подарочный сертификат</div>
          <div> {{cert.number}} </div>
          <div>{{cert.amount  | number : '1.2-2' }} </div>
        </div>
      </div>

    </div>


    <h1>Итого к оплате {{getFullOrdersPrice()  | number : '1.2-2' | currency: "EUR"}}</h1>

    <div class="information info">* При оплате товаров под заказ берется предоплата 50% (кроме оплаты подарочным
      сертификатом)
    </div>
  </div>
</ng-template>
<ng-template #ordersInfoSmallScreen>
  <div class="spinner" *ngIf="loadOrder">
    <mat-spinner></mat-spinner>
  </div>
  <div *ngIf="!loadOrder">
    <div *ngIf="productsInStock.length > 0 || productsToOrder.length > 0" class="products">
      <h2 *ngIf="productsInStock.length > 0" class="color-accent">Товары в наличии</h2>
      <h2 *ngIf="productsToOrder.length > 0 && productsInStock.length == 0" class="color-accent">Товары под заказ3</h2>
      <div class="product-table">
        <div class="table-header">
          <div>Наименование</div>
          <div>Итоговая цена, {{' \u20AC'}}</div>
        </div>
        <div *ngFor="let pr of productsInStock" class="table-row">
          <div>{{pr.product.author}} {{pr.product.name}}, {{pr.count}} шт.</div>
          <div>{{pr.product.discountPriceEuro * pr.count | number : '1.2-2'}}</div>
        </div>
        <div class="table-row">
          <div>Итого</div>
          <div>{{order.discountPrice | number : '1.2-2'}}</div>
        </div>
        <div class="table-header" *ngIf="order.promoCode">
          <div>Итого c учетом промокода</div>
          <div>{{order.promoPrice | number : '1.2-2'}}</div>
        </div>
        <div class="table-header" *ngIf="order.payForDelivery">
          <div>Доставка</div>
          <div>{{order.deliveryType.price | number : '1.2-2'}}</div>
        </div>
        <div class="table-header amount">
          <div>К оплате</div>
          <div>{{order.fullPrice | number : '1.2-2'}}</div>
        </div>
      </div>
    </div>
    <div *ngIf="productsToOrder.length > 0 && productsInStock.length > 0" class="products">
      <h2 class="color-accent">Товары под заказ4</h2>
      <div class="product-table">
        <div class="table-header">
          <div>Наименование</div>
          <div>Итоговая цена, {{' \u20AC'}} </div>
        </div>
        <div *ngFor="let pr of productsToOrder" class="table-row">
          <div>{{pr.product.author}} {{pr.product.name}}, {{pr.count}} шт.</div>
          <div>{{pr.product.discountPriceEuro * pr.count | number : '1.2-2'}}</div>
        </div>
        <div class="table-row">
          <div>Итого</div>
          <div>{{preorder.discountPrice | number : '1.2-2'}}</div>
        </div>
        <div class="table-header" *ngIf="preorder.payForDelivery">
          <div>Доставка</div>
          <div>{{preorder.deliveryType.price | number : '1.2-2'}}</div>
        </div>
        <div class="table-header amount">
          <div>К оплате *</div>
          <div>{{preorder.fullPrice | number : '1.2-2'}}</div>
        </div>
      </div>
    </div>

    <div *ngIf="certificates.length > 0" class="products">
      <h2 class="color-accent">Подарочные сертификаты</h2>
      <div class="product-table">
        <div class="table-header">
          <div>Наименование</div>
          <div>Итоговая цена, {{' \u20AC'}} </div>
        </div>

        <div *ngFor="let cert of certificates" class="table-row">
          <div>Подарочный сертификат {{cert.certificate.amount}} {{' \u20AC'}}, {{cert.count}} шт</div>
          <div>{{cert.certificate.amount * cert.count  | number : '1.2-2'}}</div>
        </div>
        <div class="table-header amount">
          <div>К оплате</div>
          <div>{{certificatesOrder.orderPrice  | number : '1.2-2'}}</div>
        </div>
      </div>
    </div>

    <div class="products" *ngIf="cartService.getGiftCardsFromStorage().length > 0">
      <h2 class="color-accent">Оплата подарочными сертификатами</h2>
      <div class="product-table">
        <div *ngFor="let cert of cartService.getGiftCardsFromStorage()" class="table-row">
          <div>Подарочный сертификат {{cert.number}} </div>
          <div>{{cert.amount  | number : '1.2-2'}} </div>
        </div>
      </div>

    </div>


    <h2>Итого к оплате</h2>
    <h2 class="full-amount">{{getFullOrdersPrice() | number : '1.2-2' | currency: "EUR"}}</h2>

  </div>
  <div class="information">* При оплате товаров под заказ берется предоплата 50% (кроме оплаты подарочным
    сертификатом)
  </div>

</ng-template>
